var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"normal-btn",class:{disabled: _vm.disabled,round: _vm.round,loading: _vm.loading},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }